import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import Branch from "models/branch"
import Department from "models/department"

export type BudgetActualsMap = {
    [branchId: string]: {
        [departmentId: string]: [
            number[], // index 0 → actuals (consultingIncome + accrued, merged)
            number[],  // index 1 → budgets
            number[],  // index 2 -> planned
            number[],  // index 3 -> forecast
            number[],  // index 4 -> funnel
            number[],  // index 5 -> consultingIncome (raw, unmerged)
            number[],  // index 6 -> accrued (raw, unmerged)
        ]
    }
}

export interface BudgetActualsSliceState {
    budgetActuals: BudgetActualsMap
    departments: Department[],
    branches: Branch[]
}

export const initialState: BudgetActualsSliceState = {
    budgetActuals: {},
    departments: [],
    branches: []
}


const budgetActualsSlice = createSlice({
    name: 'budgetActuals',
    initialState,
    reducers: {
        setBudgetActuals(state, { payload }: PayloadAction<BudgetActualsMap>) {
            state.budgetActuals = payload
        },
        setBudgetActualsSearchFields(state, { payload }: PayloadAction<{
            departments: Department[],
            branches: Branch[]
        }>) {
            state.branches = payload.branches;
            state.departments = payload.departments;
        }
    }
})

export const {
    setBudgetActuals, 
    setBudgetActualsSearchFields
} = budgetActualsSlice.actions


export default budgetActualsSlice.reducer